module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Base_01.eac47cf3.png";